export default {"src":"/_next/static/media/publicIcon.456c7d89.svg","height":24,"width":24};